/* istanbul ignore file */
export * from './ScrollTopButton';
